import React from "react";
import PropTypes from "prop-types";

import Page from "../../components/Page";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import ProjectShiftList from "../../components/ProjectShiftList";

import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import ProjectForm from "../../components/forms/ProjectForm";
import { FormMode } from "../../types/enums";

const ProjectDetailPage = (props) => (
  <Page enableGoBack title="Project details">
    <CenteredPageContentContainer>
      <PaperContainer title="Projectgegevens" isAccordion={true}>
        <ProjectForm
          mode={FormMode.VIEW}
          projectId={props.match.params.project_id}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
    <CenteredPageContentContainer>
      <PaperContainer title="Diensten van dit project">
        <ProjectShiftList projectId={props.match.params.project_id} />
      </PaperContainer>
    </CenteredPageContentContainer>
    <Fab
      variant="circular"
      color="primary"
      style={{ position: "fixed", bottom: 40, right: 40 }}
      onClick={() => {
        window.location.href = `/company/${props.match.params.company_email}/project/${props.match.params.project_id}/shift/create`;
      }}
    >
      <AddIcon />
    </Fab>
  </Page>
);

ProjectDetailPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      company_email: PropTypes.string.isRequired,
      project_id: PropTypes.string.isRequired,
    }),
  }),
};

export default ProjectDetailPage;



// WEBPACK FOOTER //
// ./src/pages/Project/ProjectDetailPage.js